<template>
    <div>
        <b-card-group columns>
            <b-card
            v-for = "(field, index) in fieldDelivery" :key="field.fieldId" :index="index"
                    @click="displayField(field)"
                    :title="field.name"
                    :img-src="field.images[0]"
                    :img-alt="field.images[0]"
                    img-top
                    style="max-width: 20rem;"
                    class="mb-2"
            >
                <b-card-text>
                    {{field.description}} gehört
                  {{field.owner.name}}
                </b-card-text>
                <b-card-text>
                    Preis pro Stunde: {{formatPrice(field.pricePerHour)}}
                </b-card-text>

                <b-button @click="goToDetails(field.fieldId)" variant="primary">Details</b-button>
            </b-card>
        </b-card-group>
      <b-modal
        id="fieldDetails"
        ref="fieldRef"
        title=""
        size="xl">
        <field-detail :id="selectedField"/>

      </b-modal>

    </div>
</template>

<script>

    import {fieldService} from "@/services/field.service";
    import {utilsService} from "@/services/utils.service";
    import {router} from "@/core/router";
    import FieldDetail from "@/components/FieldDetail";

    export default {
        name: 'FieldList',
      components: {FieldDetail},
      data() {
          return{
            selectedField: 0
          }
      },
        props:{
        fieldDelivery: Array
        },
        created() {
            this.getFields();
        },
        methods: {
            getFields() {
                fieldService.getFields().then(res => {
                    this.fields = res.items;
                });
            },
            formatPrice(priceInCent) {
                const priceInEuro = priceInCent / 100;
                return utilsService.formatCurrency(priceInEuro);
            },
            goToDetails(id) {
                router.push({path: "/home/fields/" + id})
            },
            displayField(field){
              this.selectedField = field.fieldId
              this.$bvModal.show('fieldDetails')

            }
        }
    }
</script>

<style scoped>

</style>
